var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28.1898,
    cy: 28.1898,
    r: 24.3901,
    fill: "#FFC700",
    stroke: "white",
    strokeWidth: 7.59937
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3376 37.046C25.1051 37.2799 24.7879 37.4104 24.4583 37.4104C24.1288 37.4104 23.8116 37.2799 23.5791 37.046L16.5573 30.0231C15.8285 29.2943 15.8285 28.1128 16.5573 27.3852L17.4366 26.506C18.1654 25.7772 19.3456 25.7772 20.0744 26.506L24.4583 30.8899L36.3043 19.044C37.0331 18.3152 38.2145 18.3152 38.9421 19.044L39.8214 19.9232C40.5502 20.652 40.5502 21.8335 39.8214 22.5611L25.3376 37.046Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward);
export default __webpack_public_path__ + "static/media/reward.69278391fa25061da2b0ad2431188c57.svg";
export { ForwardRef as ReactComponent };